<template>
  <div class="te-bg-banner-first-sidejob">
    <a
      class="mb-8 block h-full text-left font-bold hover:bg-co-gray-950/20"
      href="/course/first-sidejob"
    >
      <div class="w-full py-[3.25rem] pl-3 text-white md:w-3/4 md:p-10">
        <h3 class="co-display-12 leading-base">
          プログラミングを習得して
          <br class="md:hidden">
          副業で稼げるエンジニアを目指す
        </h3>
        <h2 class="text-[2rem]">
          はじめての副業
          <span class="co-display-12 ml-2">コース</span>
        </h2>
      </div>
    </a>
  </div>
</template>

<style scoped>
.te-bg-banner-first-sidejob {
  background-image: linear-gradient(
      to top,
      rgba(137, 169, 94, 0.75),
      rgba(137, 169, 94, 0.75)
    ),
    url('~/assets/images/Te/TeCommon/Banner/Firstsidejob/block-first-sidejob.webp');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  @media (min-width: 576px) {
    background-color: #89a95e;
    background-image: url('~/assets/images/Te/TeCommon/Banner/Firstsidejob/block-first-sidejob.webp');
    background-repeat: no-repeat;
    background-position: right;
    background-size: 33%;
  }
}
</style>
